import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import nls from '../../../nls/pt-BR.json';
import { setCurrentProgressTo } from '../../../redux/studies.reducer';

export const DragAndDropInstructions: React.FC = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentProgressTo(0));
  }, []);
  return (
    <div className="drag-n-drop-instructions">
      <h6>{nls.studyCreationGuide.dragAndDrop.title}</h6>
      <p>{nls.studyCreationGuide.dragAndDrop.helperText}</p>
    </div>
  );
};
